import { useContext } from "react";
import { Card } from "react-bootstrap";
import { CabinetPosition } from "../../services/WebApiClient";
import { EditorContext } from "../EditorCommon/EditorContext";

interface Position {
    key: CabinetPosition;
    name: string;
    image: string;
}

export function CabinetPositionSetter() {

    const ec = useContext(EditorContext);



    const positions: Position[] = [
        {
            key: CabinetPosition.FreeStanding,
            name: ec.translator("cabPos freeStanding", "Fritstående"),
            image: "/positions/nosides.png",
        },
        {
            key: CabinetPosition.WallLeft,
            name: ec.translator("cabPos wallLeft", "Væg Venstre"),
            image: "/positions/leftside.png",
        },
        {
            key: CabinetPosition.WallRight,
            name: ec.translator("cabPos wallRight", "Væg Højre"),
            image: "/positions/rightside.png",
        },
        {
            key: CabinetPosition.WallBoth,
            name: ec.translator("cabPos wallBoth", "Væg Begge Sider"),
            image: "/positions/bothsides.png",
        },
    ];


    const posElements = positions.map(p => {
        const border = ec.cabinet.position === p.key ? "primary" : undefined;
        return (
            <Card className="cabinet-position"
                onClick={() => ec.cabinetService.setCabinetPosition(p.key)}
                border={border}
                key={p.key}
            >
                <Card.Img variant="top" src={p.image} alt="" style={{width:"100%", aspectRatio:"auto 800 / 600", height:"auto"}} />
                <Card.Body>
                    <Card.Title>{p.name}</Card.Title>
                </Card.Body>
            </Card>
        )
    });

    return (
        <div className="cabinet-position-setter">
            <div className="cabinet-position-setter-inner">
                {posElements}
            </div>
        </div>
    );

}
